import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskChannelsEmailNextGenRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-channels-email-next-gen',
	path: '/jira/servicedesk/projects/:projectKey/settings/channels/email',
	exact: true,
};
